import { makeStyles } from '@mui/styles';

export const useClockViewStyles = makeStyles(() => ({
  // Disable the arrows on input numbers
  container: {
    '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type="number"]': {
      '-moz-appearance': 'textfield',
    },
  },
}));
